/* ============================================================================
   Scheduled sale messaging (#473)
   ----------------------------------------------------------------------------
   Every [data-sched] element carries data-start / data-end (unix seconds,
   end exclusive). Liquid already renders the right state for the moment the
   page was built; this re-checks against the visitor's clock so a cached
   page still switches on/off on time, including across the boundary while
   the page is open.
   While a scheduled item is live, <html> gets .has-sched-<type>; CSS uses it
   to hide what it replaces (regular announcement bar, old sale banner).
   ========================================================================== */
(function () {
  if (window.__apSchedSale) return;
  window.__apSchedSale = true;

  function isLive(el, now) {
    var s = parseInt(el.getAttribute('data-start'), 10);
    var e = parseInt(el.getAttribute('data-end'), 10);
    if (isNaN(s) || isNaN(e)) return false;
    return now >= s && now < e;
  }

  var timer = null;

  // Preview only: ?sched_at=2026-11-25 (or 2026-11-25T09:00) shows the page as
  // it will look at that moment (Toronto time). Visual only, never touches prices.
  var previewAt = null;
  try {
    var q = new URLSearchParams(window.location.search).get('sched_at');
    if (q && /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2})?$/.test(q)) {
      previewAt = Math.floor(new Date(q + (q.length === 10 ? 'T12:00' : '') + ':00-05:00').getTime() / 1000);
    }
  } catch (e) {}

  function apply() {
    if (timer) { clearTimeout(timer); timer = null; }
    var now = previewAt || Math.floor(Date.now() / 1000);
    var nodes = document.querySelectorAll('[data-sched]');
    var liveTypes = {};
    var next = Infinity;
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      // Theme editor: always show the selected block
      var live = isLive(el, now) || el.hasAttribute('data-sched-force');
      el.hidden = !live;
      el.classList.toggle('is-live', live);
      if (live) liveTypes[el.getAttribute('data-sched')] = true;
      var s = parseInt(el.getAttribute('data-start'), 10);
      var e = parseInt(el.getAttribute('data-end'), 10);
      if (s > now && s < next) next = s;
      if (e > now && e < next) next = e;
    }
    // Wrapper sections collapse when none of their children is live
    var groups = document.querySelectorAll('[data-sched-group]');
    for (var j = 0; j < groups.length; j++) {
      groups[j].hidden = !groups[j].querySelector('[data-sched].is-live');
    }
    // <html class="has-sched-<type>"> for every live type (announcement, banner, hero, extra)
    ['announcement', 'banner', 'hero', 'extra'].forEach(function (t) {
      document.documentElement.classList.toggle('has-sched-' + t, !!liveTypes[t]);
    });
    // Re-check at the next boundary (capped so long timers stay accurate)
    if (next !== Infinity && !previewAt) {
      var wait = Math.min((next - now) * 1000 + 500, 3600000);
      timer = setTimeout(apply, Math.max(wait, 1000));
    }
  }

  window.apSchedSaleApply = apply;
  // Run now for everything already parsed (no flash of the regular bar),
  // then again once the whole page is in.
  apply();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  }
  document.addEventListener('shopify:section:load', apply);
  document.addEventListener('shopify:block:select', function (ev) {
    var el = ev.target && ev.target.closest ? ev.target.closest('[data-sched]') : null;
    if (el) { el.setAttribute('data-sched-force', ''); apply(); }
  });
  document.addEventListener('shopify:block:deselect', function (ev) {
    var el = ev.target && ev.target.closest ? ev.target.closest('[data-sched]') : null;
    if (el) { el.removeAttribute('data-sched-force'); apply(); }
  });
})();
